import { useUserStore } from '~/stores/user'

/**
 * Fetch visitor country on enter. Must wait until app:mounted —
 * calling axios during plugin setup nests Nuxt/Pinia context
 * (interceptors also call useUserStore) and throws "Context conflict".
 */
export default defineNuxtPlugin({
  name: 'ip-region',
  dependsOn: ['pinia'],
  setup(nuxtApp) {
    const userStore = useUserStore()
    nuxtApp.hook('app:mounted', () => {
      void userStore.ensureIpRegion()
    })
  },
})
